import ModalV2 from '@/components/ModalV2.jsx';
import { setModalState } from '@/redux/actions/uiActions/modalActions.js';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import { modal } from '@/redux/selectors/uiSelectors';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors.js';
import WorkflowOutputTable from '@/screens/workflows/workflowEditor/workflowEditorPanels/primaryPanels/components/WorkflowOutputTable.jsx';
import { useSelector } from 'react-redux';

const TableModal = () => {
  const dataKey = useSelector((state) => workflowScreenSelectors.activeWorkflowStep(state)?.arguments?.dataKey);
  const modalState = useSelector(memoizeSelector('modal:table', (state) => modal(state, 'table')));

  const show = modalState?.open;
  const size = modalState?.size || 'md';
  const output = modalState?.output;

  const dataKeyOutput = output?.data?.[0]?.[dataKey];
  const outputObjects = dataKey ? dataKeyOutput : output?.data;

  const handleClose = () => {
    setModalState('table', { open: false });
  };

  return (
    <ModalV2 //
      show={show}
      className={`table-modal ${size}`}
      title={'Table Results'}
      onHide={handleClose}
      maxWidth={'90%'}
      centered>
      <WorkflowOutputTable outputData={outputObjects} />
    </ModalV2>
  );
};

export default TableModal;
